import React from "react";
import {
    TableContentForFactoryRouteWeighReport,
    TableContentForSumLeafCollectionVarianceReport
} from '../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const fieldColumnNames = this.props.fieldColumnNames;
        const fullTotalRow = this.props.fullTotalRow;
        const sumTableData = this.props.sumTableData;
        const sumFieldContentRowNames = this.props.sumFieldContentRowNames;

        return (
            <div>
                <h3><center><u>Factory Route Weigh Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div>
                    <div className="row pb-3">
                        <div className="col-md-6">
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ fontWeight: "bold" }}>Route Name</th>
                                        <th style={{ fontWeight: "bold" }}>Bag Count</th>
                                        <th style={{ fontWeight: "bold" }}>Field Gross /Kg</th>
                                        {fieldColumnNames.map((x, index) => {
                                            return (
                                                <th scope="col" key={index} style={{ fontWeight: "bold" }}>{x + " /Kg"}</th>
                                            )
                                        })}
                                        <th style={{ fontWeight: "bold" }}>Field Net /Kg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForSumLeafCollectionVarianceReport
                                        data={sumTableData}
                                        contentRowNames={sumFieldContentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th style={{ fontWeight: "bold" }}>Total</th>
                                        <th style={{ textAlign: "right", fontWeight: "bold"}}>{fullTotalRow.bagCount}</th>
                                        {contentRowNames.map((x, i) => {
                                            var res = fullTotalRow.find(y => y.name === x);

                                            if (res) {
                                                return (
                                                    <th key={i} style={{ textAlign: "right", fontWeight: "bold" }}>{res.value.toFixed(2)}</th>
                                                );
                                            } else if (res === undefined && x.includes("_Kg")) {
                                                return (
                                                    <th key={i} style={{ textAlign: "right", fontWeight: "bold" }}>{(0).toFixed(2)}</th>
                                                );
                                            }

                                        })}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <table id="factoryRouteWeighReportPdf" className="datatable-multi-row"
                                    style={{ overflowX: "auto", whiteSpace: "nowrap", width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Route Name</th>
                                            <th>Reg Number</th>
                                            <th>Reg Name</th>
                                            <th>Bag Count</th>
                                            <th>Gross /Kg</th>
                                            {fieldColumnNames.map((x, index) => {
                                                return (
                                                    <th scope="col" key={index}>{x + " /Kg"}</th>
                                                )
                                            })}
                                            <th>Net /Kg</th>
                                            <th>Leaf Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentForFactoryRouteWeighReport
                                            data={reportData}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="4">Total For Day</th>
                                            <th style={{ textAlign: "left" }}>Bag Count: {fullTotalRow.bagCount}</th>
                                            {contentRowNames.map((x, i) => {
                                                var res = fullTotalRow.find(y => y.name === x);

                                                if (res) {
                                                    return (
                                                        <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                    );
                                                } else if (res === undefined && x.includes("_Kg")) {
                                                    return (
                                                        <th key={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                    );
                                                }

                                            })}
                                            <th></th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}